var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetweetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "retweetIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.506,
    height: 17,
    viewBox: "0 0 13.506 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M0,16.86a.306.306,0,0,0,.284.284H12.511l-2.7,2.7a.267.267,0,0,0,0,.427.355.355,0,0,0,.427,0l3.2-3.2L13.506,17v-.071h0v-.142a.07.07,0,0,0-.071-.071h0l-3.2-3.2a.3.3,0,0,0-.427.427l2.7,2.7H.569V11.884A.306.306,0,0,0,.284,11.6.306.306,0,0,0,0,11.884V16.86Z",
    transform: "translate(0 -3.343)",
    fill: "var(--mainColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M0,3.621H0l.071.071,3.2,3.2a.261.261,0,0,0,.213.071A.261.261,0,0,0,3.7,6.891a.267.267,0,0,0,0-.427L1,3.763H12.937V8.454a.284.284,0,1,0,.569,0V3.479a.306.306,0,0,0-.284-.284H1L3.7.493a.267.267,0,0,0,0-.427C3.554-.076,3.412,0,3.27.067l-3.2,3.2L0,3.336v.071H0Z",
    transform: "translate(0 0.015)",
    fill: "var(--mainColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetweetIcon);
export default __webpack_public_path__ + "static/media/retweetIcon.5508c570bb6f43d979f0552ebcfd62a6.svg";
export { ForwardRef as ReactComponent };